import actions from "./actions";

const initialState = {
  loading: false,
  stats: {},
  error: false,
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
